import React, { useEffect } from 'react'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { useDispatch } from 'react-redux'
import { usePlaidLink } from 'react-plaid-link'

import { getBankAccountToken } from '../../store/actions/accountActions'

const styles = (theme) => ({
    blackBorderButton: {

        border: '1px solid black',
        color: 'black',
        '&:hover': {
            backgroundColor: 'transparent',
            border: '1px solid black '
        }
    },
})
const LinkAccountButton = ({ stripeUserInfoExists, classes, disabled, token, handleTokenCallback, label, fullWidth, primaryColor, isOAuthRedirect }) => {

    const dispatch = useDispatch();
    // console.log(disabled)
    //const [isDisabled, setIsDisabled] = useState(disabled)

    const onSuccess = React.useCallback((public_token, metadata) => {
        // send public_token to server
        if (public_token) {
            dispatch(getBankAccountToken(public_token, metadata.account_id, (err, response) => {
                if (!err) {
                    // Add card 
                    console.log(response)

                    //handleTokenCallback(response.data.bankAccountToken)
                    if (response.data && response.data.bankAccount) {
                        handleTokenCallback(response.data.bankAccount);
                    }


                }
            }))
        }

    }, []);



    const config = {
        token: token,
        onSuccess
    };

    if(isOAuthRedirect){
        config.receivedRedirectUri = window.location.href.replace("#/","");
    }


    const { open, ready } = usePlaidLink(config);


    useEffect(() => {
        // If OAuth redirect, instantly open link when it is ready instead of
        // making user click the button
        if (isOAuthRedirect && ready) {
          open();
        }
    }, [ready, open, isOAuthRedirect]);

    return isOAuthRedirect ? <></> :<Button
        variant={primaryColor ? "contained" : "outlined"}
        color="primary"
        disabled={stripeUserInfoExists === false || !disabled}
        onClick={() => open()}
        className={primaryColor ? '' : classes.blackBorderButton}
        size="large"
        fullWidth={fullWidth ?? true}
    >
        {label}
    </Button>
}

export default withStyles(styles)(LinkAccountButton)